import {Expiries} from "../../services/expiry/Expiries";
import {Simulation} from "../models/Simulation";
import {SimulationDates} from "../models/SimulationDates";
import {areSameDate, DateTimeUtil} from "../../js/util/DateTimeUtil";
import {Moment} from "moment";
import {SimulationCalculationResult} from "../models/SimulationCalculationResult";
import {Equality} from "../../types/GenericTypes";
import {HistoricalPriceRange} from "../../services/price/historical/HistoricalPriceModels";
import moment = require("moment");
import {IsoDate} from "../../pseudo-types/DateTypes";

export class TradeSimulatorViewServiceUtil {

    public static availableExpiries(simulation: Simulation,
                                    results: SimulationCalculationResult,
                                    expiries: Expiries): Array<IsoDate> {
        const today = moment().format("YYYY-MM-DD");
        const availableExpiries = expiries.forUnderlying(simulation.underlying)
                                          .ofType("MONTHLY", "QUARTERLY")
                                          .between(results.from, today)
                                          .expiryDates();
        return availableExpiries.sort();
    }

    public static calculateDateRange(range: HistoricalPriceRange, holidays: Array<Date>): SimulationDates {

        const isHoliday = (input: Moment) => {
            const mDate = input.toDate();
            return holidays.some((hol) => areSameDate(hol, mDate));
        };

        const from = moment(range.from);
        const to = moment();

        const dates: Array<string> = [];
        let current = from;

        while (current.isBefore(to)) {
            if (!isHoliday(current) && !DateTimeUtil.isWeekend(current.toDate())) {
                const formatted = current.format("YYYY-MM-DD");
                dates.push(formatted);
            }
            current = current.add(1, "days");
        }

        const formattedTo = to.format("YYYY-MM-DD");
        dates.push(formattedTo);

        return SimulationDates.create(dates);
    }

    public static distinctSimulations(): Equality<Simulation | null> {
        return (a, b) => {
            if (a == null || b == null) {
                return a === b;
            } else {
                return a.id === b.id;
            }
        };
    }
}
